// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32Tfb","tabsBox":"styles_tabsBox__3oC8Q","createButton":"styles_createButton__3mykE"};